export default __webpack_public_path__ + "static/media/speed-wind.02b52fb2.png";